import type { Drug } from "../types";

export const doxycyclineDrug: Drug = {
  id: "doxycycline",
  name: "Doxycycline",
  drugClass: "tetracycline",
  route: "oral",
  defaultFoodTiming: "Take with food or water",
  swallowingNote: "Capsules should be swallowed whole with a full glass of water while sitting or standing",
  formulations: [
    {
      id: "doxy-100-cap",
      type: "capsule_ir",
      strength: 100,
      strengthUnit: "mg",
      prescribedItemId: "59a2ac8b-bfa2-4d57-86c8-737565944379",
    },
  ],
};
